import React, { useState } from "react";

const Drawer = ({ drawerId, children, isOpen, openDrawer, className }) => {
  return (
    <>
      {/* <button
        data-drawer-show={drawerId}
        onClick={openDrawer}
        className="btn btn-open w-full my-5 px-5 text-gray_900 font-light text-sm underline flex justify-end"
      >
      Show Version History
      </button> */}

      <div
        id={drawerId}
        className={`fixed top-0 right-0 h-full w-[400px] z-[100] bg-gray_50 shadow-lg transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } ${className}`}
      >
        {children}
      </div>
      {/* <div
        className={`bg-overlay fixed inset-0 transition-opacity ${
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={closeDrawer}
      ></div> */}
    </>
  );
};

export default Drawer;
